import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { createNewRole } from '../../../../../../lib/api/users/roles';
import CustomButton from '../../../../../../lib/designSystem/Button';
import { showAlert } from '../../../../../../lib/functions/utils';

type Props = {
  open: boolean;
  onClose: () => void;
  onRoleCreated: (roleName: string) => Promise<void>;
};

const AddRoleDialog: React.FC<Props> = ({ open, onClose, onRoleCreated }) => {
  const dispatch = useDispatch();
  const [roleName, setRoleName] = useState('');
  const [loading, setLoading] = useState(false);
  const handleAddRole = async () => {
    try {
      setLoading(true);
      await createNewRole(dispatch, { name: roleName });
      await onRoleCreated(roleName);
      showAlert(dispatch, 'success', 'Rol creado correctamente');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      {loading ? (
        <CenteredCircularProgress />
      ) : (
        <div>
          <Typography variant="h4" padding="10px 10px">
            Agregar Rol
          </Typography>
          <DialogContent>
            <TextField
              label="Nombre del Rol"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <CustomButton onClick={onClose} color="secondary">
              Cancelar
            </CustomButton>
            <CustomButton onClick={handleAddRole} color="primary">
              Guardar
            </CustomButton>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
};

export default AddRoleDialog;
